import { useIsPublicPage } from "lib/routing";
import { tryDoFetch } from "lib/tryDoFetch";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";

const MENU_DATA_URL = "/research/japi/content/assets/menu.json";

export const MenuDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isPublicPage = useIsPublicPage();

  useEffect(() => {
    async function fetchData() {
      if (isPublicPage) return;
      const data = await tryDoFetch(MENU_DATA_URL, null, "GET", console.error);
      const menuData = tryParseMenu(data);
      if (menuData) dispatch(miscSlice.actions.set({ key: "menuData", value: menuData }));
    }
    fetchData();
  }, [dispatch, isPublicPage]);

  return children;
};

export function tryParseMenu(data) {
  if (!data) return null;
  try {
    populateHomePeriodicals(data["periodicals.en"]);
    populateHomePeriodicals(data["periodicals.ja"]);
  } catch (err) {
    console.error("Cannot parse menu data:", err);
  }
  return data;
}

function populateHomePeriodicals(periodicals) {
  periodicals.Home = aggregateAssetClasses(periodicals);
}

const aggregateAssetClasses = (data) => data.Home;
